import { connect } from 'react-redux';

import { closeAboutModal, fetchServices } from '../../service/AboutModal.actions';
import { isAboutModalVisible, getAboutModalServices } from '../../service/AboutModal.selectors';
import { AboutModal, AboutModalDispatchProps, AboutModalMapProps } from './AboutModal.component';

const mapStateToProps = (store: any): AboutModalMapProps => {
	return {
		show: isAboutModalVisible(store),
		backendServices: getAboutModalServices(store),
	};
};

const mapDispatch = (dispatch: Function): AboutModalDispatchProps => {
	return {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		onHide: () => dispatch(closeAboutModal()),
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		fetchServices: () => dispatch(fetchServices()),
	};
};

export const ConnectedAboutModal = connect(mapStateToProps, mapDispatch)(AboutModal);
